import React from "react";
import matterImg from "../../common/images/matters-left.png";
const UIUXSection = () => {
  return (
    <div className="bg-gradient-to-b from-blue-100 to-white">
    <section className="max-w-[1280px] mx-auto md:px-10 px-5 md:py-7 py-5  md:flex gap-4 md:items-center">
      <div className="md:w-1/2 text-left">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-medium text-gray-900">
          <span className="text-[#0964AC]">Why</span>
          <div className="flex items-center  font-bold mt-2 text-[#0964AC]">
            <span >It</span>
            <span className="block sm:inline text-[#FFCB00] mx-2">
              {" "}
              Matters
            </span>
          </div>
        </h2>
        <div className="underline w-2/5 flex justify-center  my-4 items-center h-[2px] rounded-md bg-secondary">
          <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
        </div>{" "}
        <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed">
          A well-designed <strong>UI/UX</strong> improves user retention,
          increases conversion rates, and strengthens brand loyalty. We ensure
          that your digital presence not only looks good but also functions
          smoothly, giving your users a seamless experience.
        </p>
      </div>
      <div className="md:w-1/2 mt-10 md:mt-0">
        <img
          src={matterImg}
          alt="UI/UX Design"
          className="w-[90%] mx-auto "
        />
      </div>
    </section>
    </div>
  );
};

export default UIUXSection;
